'use strict';

var DEFAULT_THUMBNAIL = '//stampsy-eu-1.s3.amazonaws.com/2014/10/14/images/user.png';

function getUserThumbnail(user) {
  if (user.thumbnailUrl) {
    return {
      isDefault: false,
      url: user.thumbnailUrl
    };
  }

  return {
    isDefault: true,
    url: DEFAULT_THUMBNAIL
  };
}

module.exports = getUserThumbnail;


/** WEBPACK FOOTER **
 ** ./utils/getUserThumbnail.js
 **/